module.exports = __webpack_public_path__ + "static/media/12_tearsofhair.f17836ae.jpg";